module.exports = __webpack_public_path__ + "static/media/Goldvestrate.84314aa6.svg";